export const CUSTOM_MESSAGE_ELEMENT_ID = 'custom-message';
export const CUSTOM_MESSAGE_SELECTOR = `#${CUSTOM_MESSAGE_ELEMENT_ID}`;

export const EMPTY_MESSAGE_PLACEHOLDER =
  '<span style="color: #999; font-style: italic;">Click here to add your custom message</span>';

export const CUSTOM_MESSAGE_TEMPLATE_PLACEHOLDER = '{{customMessage}}';
